<template>
  <div class="grid grid-pad box-size" style="overflow: initial">
    <div class="col-1-1 text-dark">
      <div class="substitution">
        <div class="header width-100">
          <div class="flex space-between align-center">
            <h1>{{ $t('vue2.substitution.substitution') }}</h1>
            <div class="substitution__header__right">
              <SubsAbsentWithoutEnd></SubsAbsentWithoutEnd>
              <SubsNote :date="getDate" v-if="userCanSeeInternalNote"></SubsNote>
              <button class="marg-10-right no-print aku-button"
                      @click="setIsModalOutOfSchool(true)"
                      v-if="isTestingCreateAKU">
                Opret klassefravær
              </button>
              <button @click="print"
                      v-if="!localSchedulerView"
                      class="marg-10-right no-print"
                      style="height: 38px;width: 38px">
                <span class="icon-printer3"></span>
              </button>
              <button @click="setToday"
                      :class="{inactive: isToday}"
                      class="date-buttons marg-5-right">
                {{ $t('vue2.substitution.today') }}
              </button>
              <button @click="prevDay" class="date-buttons marg-5-right">
                <span class="icon-arrow-left4"></span>
              </button>
              <DatePicker
                :date="getDate"
                @changed="setDate">
              </DatePicker>
              <button @click="nextDay" class="marg-5-left date-buttons">
                <span class="icon-arrow-right4"></span>
              </button>
              <SubstitutionCreate
                :schoolId="schoolId"
                :users="allUsersSortedOnName"
                :usersWithOngoingAbsenceInHash="usersWithOngoingAbsenceInHash"
                :allUsersInCalIdHash="allUsersInCalIdHash">
              </SubstitutionCreate>
            </div>
          </div>
        </div>
        <div class="sub-header__subHeader">
          <div class="absentUsersFilters">
            <div class="absentUsersFilters__filter" @click="setAbsentFilter('')"
                 :class="{'absentUsersFilters__filter--active': isAbsentUserFilter('')}">
              <div class="absentUsersFilters__filter__number">{{ absentUsersFromUserSet.length }}</div>
              {{ i18n[locale]['absent_today'] }}
            </div>
            <div class="absentUsersFilters__filter" @click="setAbsentFilter('handled')"
                 :class="{'absentUsersFilters__filter--active': isAbsentUserFilter('handled')}">
              <div class="absentUsersFilters__filter__number">{{ absentUsersHandled.length }}</div>
              {{ i18n[locale]['absent_handled'] }}
            </div>
            <div class="absentUsersFilters__filter" @click="setAbsentFilter('unhandled')"
                 :class="{'absentUsersFilters__filter--active': isAbsentUserFilter('unhandled')}">
              <div class="absentUsersFilters__filter__number">{{ absentUsersUnhandled.length }}</div>
              {{ i18n[locale]['absent_unhandled'] }}
            </div>
          </div>
          <app-flipper-button
            :preselectedTab="activeTab"
            @update="setSchedulerView">
          </app-flipper-button>
        </div>
        <spinner v-if="(isLoadingSchoolCalenders || dataIsLoading) && !localSchedulerView" color="blue"
                 style="margin-top: 150px"></spinner>
        <template v-if="!localSchedulerView && !dataIsLoading && !isLoadingSchoolCalenders">
          <SubsUser v-for="(user, idx) in absentUsers"
                    :user="user"
                    :activeDSelect="activeDSelect"
                    :key="user.id"
                    :date="getDate"
                    :allEvents="allEvents"
                    :calsAndEventIds="calsAndEventIds"
                    :allEventsInAHash="allEventsInAHash"
                    :allUsersSortedOnName="allUsersSortedOnName"
                    :allUsersAndEvents="allUsersAndEvents"
                    :allCalendarsInAHash="allCalendarsInAHash"
                    :longAbsentListInHash="longAbsentListInHash"
                    :absentUsersHandledHash="absentUsersHandledHash"
                    :isSubStatusPendingActive="isSubStatusPendingActive"
                    @splitLesson="setSplitLesson"
                    @setActiveDSelect="setActiveDSelect"
                    @selectedUser="selectedUser = user"
                    @removeSubs="setRemoveSubsFromEvent"
                    @showLog="showEventLog">
          </SubsUser>
        </template>
        <!-- SCHEDULER -->
        <template v-if="localSchedulerView">
          <div class="sub-scheduler">
            <div class="sub-scheduler__header">
              <div class="sub-scheduler__header__left">
                <div class="sub-scheduler__filters sub-scheduler__filters__subzen">
                  <SchedulerSort
                    :selected="selectedSort"
                    :locale="locale"
                    @onSortBy="onSortBy">
                  </SchedulerSort>
                  <transition name="fadeInLeft">
                    <scheduler-prioritizer
                      v-if="selectedSort === 'subzen'"
                      :propsIsPrioritizerActive="isPrioritizerActive"
                      @setIsPrioritizerActive="isPrioritizerActive = $event">
                    </scheduler-prioritizer>
                  </transition>
                </div>
              </div>
              <div class="sub-scheduler__header__right sub-scheduler__header__right__filters">
                <DoFiltersFilter
                  :title="i18n[locale]['absent']"
                  :tags="tags"
                  :selectedTags="appliedFiltersAbsentUsers"
                  @select="toggleAbsentFilter"
                  @clear="clearAllAbsentFilters"
                >
                </DoFiltersFilter>
                <DoFilters
                  :tags="tags"
                  :selectedTags="appliedFilters"
                  @select="toggleTag"
                  @clear="clearAllTags"
                  :selectedQuickFilters="selectedQuickFilters"
                  @toggleQuickFilter="toggleQuickFilter($event)"
                  @clearAll="clearAllFiltersForSubs">
                </DoFilters>
              </div>
            </div>
            <scheduler
              :title="text"
              :subsTitle="subsHeadline"
              :items="absentAndSubs"
              :isSortOnName="sortOnName"
              :date="getDate"
              :isSubStatusPendingActive="isSubStatusPendingActive"
              :allCalendarsInHash="allCalendarsInAHash"
              :longAbsentListInHash="longAbsentListInHash"
              @removeSubs="setRemoveSubsFromEvent"
              @showLog="showEventLog"
              @setCreateEventOnUser="setCreateEventOnUser"
              @splitLesson="setSplitLesson"
              @setTheOutOfSchoolLesson="setTheOutOfSchoolLesson($event)">
            </scheduler>
          </div>
        </template>
      </div>
      <splitLesson
        v-if="activeSplitLesson !== null"
        :lesson="activeSplitLesson"
        @submitted="onSubmittedSplitEvent"
        @closeSplitEvent="closeSplitLesson">
      </splitLesson>
      <AppModal
        :submitTxt="i18n[locale]['button_text']"
        v-if="isModal"
        @close="isModal = false"
        @submit="removeSubs">
        <h2 class="pad-10" slot="header">
          {{ i18n[locale]['remove_subs'] }}
        </h2>
        <div slot="body">
          <h2>{{ i18n[locale]['substitutes_for'] }}</h2>
          <ul class="marg-20-top marg-20-bottom bold text-blue">
            <li v-for="sub in userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved" :key="sub">
              {{ allUsersInCalIdHash[sub].name }}
            </li>
          </ul>
          <p class="marg-5-bottom">
            {{ i18n[locale]['has_to_remove_subs'] }}
          </p>
          <p>
            {{ i18n[locale]['click_on_remove_all'] }}
          </p>
        </div>
      </AppModal>
      <AppModal
        submitTxt="OK"
        v-if="eventChangesEvent"
        :isShowFooter="false"
        @close="eventChangesEvent = null">
        <h2 class="pad-10" slot="header">{{ eventChangesEvent.title }}</h2>
        <div slot="body">
          <EventChanges :event-id="eventChangesEvent.id"></EventChanges>
        </div>
      </AppModal>
    </div>
    <SubsEditAbsence v-if="activeAbsenceReason"></SubsEditAbsence>
    <SubsUserPanel
      v-if="activeAbsentUser"
      :activeDate="getDate"
      :isSubStatusPendingActive="isSubStatusPendingActive"
      @close="setActiveAbsentUser(null)"
      @readEvents="readEvents"></SubsUserPanel>
    <CreateTask
      v-if="createEventOnUser && createEventOnUser.user"
      :user="createEventOnUser.user"
      :initDate="createEventOnUser.date"
      @close="setCreateEventOnUser (null)">
    </CreateTask>
    <OutOfSchool
      v-if="isModalOutOfSchool"
      :initDate="getDate"
      @onCreatedEvents="readEvents"
      @close="setIsModalOutOfSchool(false)">
    </OutOfSchool>
    <DModalOutOfSchoolLesson
      v-if="theOutOfSchoolLesson"
      :event="theOutOfSchoolLesson"
      :eventIdProp="'id'"
      @updated="onOutOfSchoolLessonUpdated"
      @close="setTheOutOfSchoolLesson(null)">
    </DModalOutOfSchoolLesson>
  </div>
</template>

<script>
import DatePicker from '../datepicker/DateSelector'
import SubstitutionCreate from './SubsCreate'
import SubsUser from './SubsUser'
import appFlipperButton from '../common/AppFlipperButtons'
import filterTags from '../Tagging/TaggingFilter'
import DoFilters from '../DoFilters/DoFilters.vue'
import scheduler from './Scheduler/Scheduler'
import appToggleButton from '../common/AppToggle'
import spinner from '../common/Loader'
import splitLesson from './SubsEventSplit'
import SubsNote from './SubsNote'
import EventChanges from '../Log/EventChanges'
import AppModal from '../common/AppModal'
import {mapGetters} from 'vuex'
import docendo from '../../docendo'
import moment from 'moment'
import SchedulerPrioritizer from './Scheduler/SchedulerPrioritizer'
import SubsAbsentWithoutEnd from './SubsAbsentWithoutEnd'
import SubsEditAbsence from './SubsEditAbsence'
import SubsUserPanel from './SubsUserPanel/SubsUserPanel'
import eventbus from '../../eventbus'
import CreateTask from '../CreateTask/CreateTask.vue'
import OutOfSchool from './OutOfSchool/OutOfSchool.vue'
import DFilters from '../common/DFilters.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import DModalOutOfSchoolLesson from '../Events/DModalOutOfSchoolLesson.vue'
import SchedulerSort from './Scheduler/SchedulerSort.vue'

export default {
  components: {
    SchedulerSort,
    DModalOutOfSchoolLesson,
    DoFiltersFilter,
    DFilters,
    OutOfSchool,
    CreateTask,
    SubsUserPanel,
    SchedulerPrioritizer,
    scheduler,
    SubsUser,
    filterTags,
    DatePicker,
    SubstitutionCreate,
    appFlipperButton,
    appToggleButton,
    spinner,
    splitLesson,
    AppModal,
    SubsNote,
    EventChanges,
    SubsAbsentWithoutEnd,
    SubsEditAbsence,
    DoFilters
  },
  data () {
    return {
      selectedSort: 'name',
      localSchedulerView: true,
      selectedQuickFilters: [],
      appliedFilters: [],
      appliedFiltersAbsentUsers: [],
      selectedUser: null,
      sortOnName: true,
      isSortOnSubPools: false,
      sortOnSubPoolsAsc: true,
      sortOnDayPresence: false,
      activeSplitLesson: null,
      activeDSelect: null,
      isModal: false,
      userAndLessonAndSubsToBeDeleted: {
        user: {},
        lesson: {},
        subToBeRemoved: {},
        subsForTheSubToBeRemoved: []
      },
      eventChangesEvent: null,
      isFilterAbsentUsersWithHandledLessons: false,
      absentFilter: '',
      createEventOnUser: null,
      isModalOutOfSchool: false,
      theOutOfSchoolLesson: null,
      isPrioritizerActive: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    isTestingCreateAKU () {
      const schoolIds = [7272, 62084, 60494, 60598, 60032, 61476, 62676, 60095, 62000, 444739, 62765, 63076]
      return schoolIds.indexOf(this.schoolId) !== -1
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    allEvents () {
      return this.$store.state.subs.allEvents
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    allUsersAndEvents () {
      return this.$store.state.subs.allUsersAndEvents
    },
    allCalendarsInAHash () {
      return this.$store.getters.allCalendarsInHash
    },
    longAbsentListInHash () {
      return this.$store.getters.longAbsentListInHash
    },
    calsAndEventIds () {
      return this.$store.state.subs.allCalsWithEventIdsInHash
    },
    absentUsersHandledHash () {
      return this.$store.getters.absentUsersHandledHash
    },
    user () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    ...mapGetters([
      'allUsersSortedOnName',
      'userSet',
      'absentUsersFromUserSet',
      'notAbsentUsersFromUserSet',
      'allUsersInCalIdHash',
      'absentUsersUnhandled',
      'absentUsersHandled',
      'isSubStatusPendingActive',
      'usersWithOngoingAbsenceInHash'
    ]),
    i18n () {
      return {
        da: {
          filters_saved_locally: 'Filtre gemt lokalt på din enhed',
          remove_subs: 'Fjern følgende vikarer',
          substitutes_for: 'Fjern følgende vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' på ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
          has_to_remove_subs: 'Du er ved at fjerne en vikar, som har fået vikardækket lektionen af en anden vikar. Før du kan fortsætte, skal vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes.',
          click_on_remove_all: 'Klik \'fjern alle\' for at gøre dette.',
          button_text: 'Fjern alle',
          absent_today: 'Fraværende i dag',
          absent_handled: 'Håndterede',
          absent_unhandled: 'Ikke-håndterede',
          absent: 'Fraværende'
        },
        en: {
          filters_saved_locally: 'Filters saved locally on your device',
          remove_subs: 'Remove substitute teachers',
          substitutes_for: 'Remove substitutes for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' in ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
          has_to_remove_subs: 'You are about to delete a substitute teacher that has been substituted by another substitute teacher. To continue, the substitute teacher for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' has to be removed',
          click_on_remove_all: 'Press \'remove all\' to continue.',
          button_text: 'Remove all',
          absent_today: 'Absent today',
          absent_handled: 'Handled',
          absent_unhandled: 'Unhandled',
          absent: 'Absent'
        },
        nb: {
          filters_saved_locally: 'Filtre lagret lokalt på enheten din',
          remove_subs: 'Fjern vikar',
          substitutes_for: 'Fjern vikarer for ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' i ' + this.userAndLessonAndSubsToBeDeleted.lesson.title,
          has_to_remove_subs: 'Du kommer nå til å fjerne en vikar som har blitt erstattet av en annen vikar. For å fortsette skal vikarer for  ' + this.userAndLessonAndSubsToBeDeleted.subToBeRemoved.name + ' fjernes',
          click_on_remove_all: 'Klikk på \'fjern alle\' for å gjennomføre dette.',
          button_text: 'Fjern alle',
          absent_today: 'Fraværende i dag',
          absent_handled: 'Håndtert',
          absent_unhandled: 'Ikke håndtert',
          absent: 'Fraværende'
        }
      }
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    userCanSeeInternalNote () {
      const lang = this.locale
      if (!lang || lang.toLowerCase() === 'en') {
        return false
      }
      return this.userHasPermission('can_manage_school')
    },
    dataIsLoading () {
      return this.$store.state.subs.dataIsLoading
    },
    sortSubs () {
      return this.$store.state.subs.sortSubs
    },
    activeTab () {
      return this.localSchedulerView ? 1 : 0
    },
    allUsers () {
      return this.$store.state.subs.allUsers
    },
    getDate () {
      return this.$store.state.subs.date
    },
    isSubScoreActive () {
      return this.$store.state.subs.isSortSubActive
    },
    text () {
      return this.$t('vue2.sub_scheduler.absent_people') + ': ' + this.filteredAbsentUsers.length + ' ' + this.$t('vue2.sub_scheduler.out_of') + ' ' + this.absentUsersFromUserSet.length
    },
    subsHeadline () {
      return this.$t('vue2.sub_scheduler.potential_substitutes') + ': ' + this.filteredNotAbsentUsers.filter(user => !user.headline).length
    },
    isToday () {
      return moment.utc().format('YYYY-MM-DD') === moment(this.getDate).format('YYYY-MM-DD')
    },
    absentUsers () {
      if (this.absentFilter === 'unhandled') {
        return this.absentUsersUnhandled
      } else if (this.absentFilter === 'handled') {
        return this.absentUsersHandled
      } else {
        return this.absentUsersFromUserSet
      }
    },
    filteredAbsentUsers () {
      let passedUsers = this.absentUsers
      if (this.appliedFiltersAbsentUsers.length > 0) {
        passedUsers = passedUsers.filter(user => user.headline || user.user_tags.some(tag => this.appliedFiltersAbsentUsers.includes(tag)))
      }
      return passedUsers
    },
    filteredNotAbsentUsers () {
      let passedUsers = this.notAbsentUsersFromUserSet
      if (this.appliedFilters.length === 0 && this.selectedQuickFilters.length === 0) {
        return passedUsers
      }

      const isAvailableActive = this.selectedQuickFilters.includes('sub_events_available')
      const isCanceledActive = this.selectedQuickFilters.includes('sub_events_canceled')
      const isTwoInClassActive = this.selectedQuickFilters.includes('sub_events_two_in_some_class')

      return passedUsers.filter(user => {
        if (isAvailableActive && user.dayAvailability && user.dayAvailability.length > 0) {
          return true
        }
        if (isCanceledActive && user.canceledEvents && user.canceledEvents.length > 0) {
          return true
        }
        if (isTwoInClassActive && (
          (user.v_two_in_class_events && user.v_two_in_class_events.length > 0) ||
          (user.v_two_events_in_class_events && user.v_two_events_in_class_events.length > 0)
        )) {
          return true
        }
        if (user.headline) {
          return true
        }
        const tagMatches = user.user_tags && user.user_tags.some(tag => this.appliedFilters.includes(tag))
        if (tagMatches) {
          return true
        }
        return false
      })
    },
    absentAndSubs () {
      if (!this.localSchedulerView) return []

      const headline = {
        name: this.$t('vue2.sub_scheduler.potential_subs'),
        id: 12312312312312313123123123,
        dayAbsence: [],
        dayPresence: [],
        dayEvents: [],
        headline: true
      }

      let subs = [...this.filteredNotAbsentUsers]

      const sortFunctions = {
        subScore: (a, b) => b.subScore - a.subScore,
        subPools: (a, b) => this.sortOnSubPoolsAsc ? a.subPoolsDiff - b.subPoolsDiff : b.subPoolsDiff - a.subPoolsDiff,
        dayPresence: (a, b) => b.dayPresence.length - a.dayPresence.length,
        name: () => this.$helpers.sortArrOnName(subs)
      }

      const shouldSort = (this.isSubScoreActive && this.sortSubs !== 0) || (!this.isSubScoreActive && this.isSortOnSubPools && this.sortSubs !== 0) || this.sortOnDayPresence || this.sortOnName

      if (shouldSort) {
        subs = subs.filter(user => !user.headline)

        if (this.isSubScoreActive && this.sortSubs !== 0) {
          subs.sort(sortFunctions.subScore)
        } else if (this.isSortOnSubPools && this.sortSubs !== 0) {
          subs.sort(sortFunctions.subPools)
        } else if (this.sortOnDayPresence) {
          subs.sort(sortFunctions.dayPresence)
        } else if (this.sortOnName) {
          sortFunctions.name()
        }

        subs.unshift(headline)
      } else if (subs.length === 0 || !subs[0].headline) {
        subs.unshift(headline)
      }

      return [...this.filteredAbsentUsers, ...subs]
    },
    activeAbsenceReason () {
      return this.$store.state.subs.activeAbsenceReason
    },
    activeAbsentUser () {
      return this.$store.state.subs.activeAbsentUser
    }
  },
  watch: {
    userSettings (val) {
      this.applyUserSettings(val)
    },
    isSubScoreActive (val) {
      this.sortOnName = !val
    }
  },
  methods: {
    setTheOutOfSchoolLesson (obj = null) {
      this.theOutOfSchoolLesson = obj
    },
    onOutOfSchoolLessonUpdated () {
      this.setTheOutOfSchoolLesson(null)
      this.readEvents()
      this.$nextTick(_ => {
        const el = document.getElementById('djs-body-click')
        if (el) {
          el.click()
        }
      })
    },
    setIsModalOutOfSchool (bool) {
      this.isModalOutOfSchool = bool
    },
    setCreateEventOnUser (userAndDateObj) {
      this.createEventOnUser = userAndDateObj
    },
    userHasPermission (val) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(val) > -1 || this.user.admin
      } else {
        return true
      }
    },
    setActiveAbsentUser (user) {
      this.$store.commit('setActiveAbsentUser', user)
    },
    setAbsentFilter (filter) {
      this.absentFilter = filter
    },
    isAbsentUserFilter (filter) {
      return this.absentFilter === filter
    },
    showEventLog (event) {
      this.eventChangesEvent = event
    },
    setActiveDSelect (userAndLessonId) {
      this.activeDSelect = userAndLessonId
    },
    setRemoveSubsFromEvent (userAndLessonAndSubsForUser) {
      this.userAndLessonAndSubsToBeDeleted = userAndLessonAndSubsForUser
      this.isModal = true
    },
    removeSubs () {
      // Remove subs for the sub
      const lesson = this.userAndLessonAndSubsToBeDeleted.lesson
      this.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved.forEach(sub => {
        this.removeSub(this.allUsersInCalIdHash[sub], this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson)
      })
      // Remove the sub
      this.removeSub(this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, this.userAndLessonAndSubsToBeDeleted.user, lesson)
      this.setSubStatusOnLesson(this.userAndLessonAndSubsToBeDeleted.user, this.userAndLessonAndSubsToBeDeleted.subToBeRemoved, lesson)
      this.isModal = false
      // this.userAndLessonAndSubsToBeDeleted = {}
    },
    removeSub (sub, subFor, lesson) {
      docendo.eventRemoveSubstitute(lesson.id, sub.id, subFor.id, data => {
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$store.commit('removeEventOnAllUsersWithEvents', {
          cal_id: sub.user_calendar_id,
          event_id: lesson.id
        })
      })
    },
    setSubStatusOnLesson (user, sub, lesson) {
      let statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
      statusData[user.user_calendar_id] = {'status': 0}
      statusData[sub.user_calendar_id] = {'status': 0}
      docendo.updateEvent(lesson.school_id, lesson.id, {substitution_status: JSON.stringify(statusData)}, success => {
        this.$store.commit('updateSubStatusOnEvent', {
          'eventId': lesson.id,
          'status': JSON.stringify(statusData)
        })
      })
    },
    onSortBy (selected, saveInLocalStorage = true) {
      this.resetSort()
      this.selectedSort = selected
      if (selected === 'subzen') {
        this.$store.commit('setIsSubScoreActive', true)
      }
      if (selected === 'pools') {
        this.isSortOnSubPools = true
      }
      if (selected === 'poolsAsc') {
        this.isSortOnSubPools = true
        this.sortOnSubPoolsAsc = true
      }
      if (selected === 'name') {
        this.sortOnName = true
      }
      if (selected === 'workHours') {
        this.sortOnDayPresence = true
      }
      this.$store.commit('setSortSubsAgain')
      const saveSortSetting = {'selectedSubSchedulerSorting': selected}
      if (saveInLocalStorage) {
        this.$store.dispatch('updateUserSettings', saveSortSetting)
      }
    },
    resetSort () {
      this.sortOnName = false
      this.isSortOnSubPools = false
      this.sortOnSubPoolsAsc = false
      this.sortOnDayPresence = false
      this.$store.commit('setIsSubScoreActive', false)
    },
    setIsSubScoreActive (boolean) {
      this.$store.dispatch('updateIsSubZenActive', boolean)
    },
    setSchedulerView (num) {
      if (num === 1) {
        this.localSchedulerView = true
        this.$helpers.removeLocalStorage('subListView')
      } else {
        this.localSchedulerView = false
        this.$helpers.setLocalStorage('subListView', true)
      }
      this.setActiveDSelect(null)
    },
    prevDay () {
      this.$store.commit('setSubDate', moment(this.getDate).subtract(1, 'days'))
      this.readEvents()
      this.$store.dispatch('subsGetLongAbsenceList')
      this.setActiveDSelect(null)
    },
    nextDay () {
      this.$store.commit('setSubDate', moment(this.getDate).add(1, 'days'))
      this.readEvents()
      this.$store.dispatch('subsGetLongAbsenceList')
      this.setActiveDSelect(null)
    },
    setToday () {
      this.$store.commit('setSubDate', moment.utc().format('YYYY-MM-DD'))
      this.readEvents()
      this.$store.dispatch('subsGetLongAbsenceList')
      this.setActiveDSelect(null)
    },
    setDate (date) {
      this.$store.commit('setSubDate', date)
      this.readEvents()
      this.$store.dispatch('subsGetLongAbsenceList')
      this.setActiveDSelect(null)
    },
    print () {
      window.print()
    },
    updateLocalStorage (keyStr, items) {
      const key = keyStr + '_' + this.schoolId
      if (items.length > 0) {
        this.$helpers.setLocalStorage(key, JSON.stringify(items))
      } else {
        this.$helpers.removeLocalStorage(key)
      }
    },
    toggleQuickFilter (quickFilter) {
      const val = quickFilter.value
      const idx = this.selectedQuickFilters.indexOf(val)
      if (idx > -1) {
        this.selectedQuickFilters.splice(idx, 1)
      } else {
        this.selectedQuickFilters.push(val)
      }
      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters)
    },
    setTagFromFilter (tag) {
      this.appliedFilters.push(tag)
      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters)
      eventbus.toast = {text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft'}
    },
    removeTagFromFilter (tag) {
      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1)
      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters)
    },
    toggleTag (tag) {
      const idx = this.appliedFilters.indexOf(tag)
      if (idx > -1) {
        this.removeTagFromFilter(tag)
      } else {
        this.setTagFromFilter(tag)
      }
    },
    clearAllTags () {
      this.appliedFilters = []
      this.updateLocalStorage('d_applied_filters_subs', this.appliedFilters)
      this.selectedQuickFilters = []
      this.updateLocalStorage('d_applied_event_filters_subs', this.selectedQuickFilters)
    },
    clearAllFiltersForSubs () {
      this.clearAllTags()
    },
    setTagFromFilterOnAbsentUsers (tag) {
      this.appliedFiltersAbsentUsers.push(tag)
      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers)
      eventbus.toast = {text: this.i18n[this.locale]['filters_saved_locally'], 'success': true, position: 'bottomLeft'}
    },
    removeTagFromFilterOnAbsentUsers (tag) {
      this.appliedFiltersAbsentUsers.splice(this.appliedFiltersAbsentUsers.indexOf(tag), 1)
      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers)
    },
    toggleAbsentFilter (tag) {
      const idx = this.appliedFiltersAbsentUsers.indexOf(tag)
      if (idx > -1) {
        this.removeTagFromFilterOnAbsentUsers(tag)
      } else {
        this.setTagFromFilterOnAbsentUsers(tag)
      }
    },
    clearAllAbsentFilters () {
      this.appliedFiltersAbsentUsers = []
      this.updateLocalStorage('d_applied_filters_absent', this.appliedFiltersAbsentUsers)
    },
    getTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    },
    setSplitLesson (lesson) {
      this.activeSplitLesson = lesson
    },
    closeSplitLesson () {
      this.activeSplitLesson = null
    },
    onSubmittedSplitEvent () {
      this.activeSplitLesson = null
      this.closeSchedulerPopover()
    },
    closeSchedulerPopover () {
      this.$store.commit('setActiveUser', null)
      this.$store.commit('setActiveEvent', null)
      this.$store.dispatch('setActiveSchedulerEvent', {
        'left': -10,
        'right': -10,
        'color': '',
        'oldSubScoreMeta': this.subScoreMeta,
        'obj': null
      })
    },
    readEvents () {
      const checkIfUserIsMemberOfAllSchools = (schoolIdsToCall) => {
        const userSchools = this.user && this.user.schools ? this.user.schools : null
        if (!userSchools) {
          return true // If user is not loaded then try to call and see
        }
        const userSchoolIds = userSchools.map(school => school.id)
        // Check if every schoolId in schoolIdsToCall exists in userSchoolIds
        return schoolIdsToCall.every(id => userSchoolIds.includes(id))
      }
      const activeSchoolId = this.schoolId * 1
      // CUSTOM CALLS FOR SCHOOLS WITH MULTIPLE SCHOOL_IDS
      const isSchoolSorenKanneFaelles = activeSchoolId === 60494
      if (isSchoolSorenKanneFaelles) {
        const schoolIdsFromSorenKanne = [60489, 60490, 60491, 60492, 60494]
        const storeObj = {
          schoolIds: schoolIdsFromSorenKanne,
          isShowEventsFromOtherThanActiveSchool: true
        }
        this.$store.dispatch('readAllEvents', storeObj)
        return
      }
      const schoolIdsFromLillevang = [59488, 59489]
      const schoolIdsFromHerlevBySkole = [57481, 17269]
      const schoolIdsFromKildegaard = [23481, 57727]
      const schoolsIdsFromBorneby = [60458, 60459, 60460, 60495]
      const schoolIdsFromSolsort = [7272, 62084]
      const isIdxInHerlevArr = schoolIdsFromHerlevBySkole.indexOf(activeSchoolId)
      const isIdxInKildeArr = schoolIdsFromKildegaard.indexOf(activeSchoolId)
      const isIdxInLillevangArr = schoolIdsFromLillevang.indexOf(activeSchoolId)
      const isIdxInBornebyArr = schoolsIdsFromBorneby.indexOf(activeSchoolId)
      const isIdsInSolsort = schoolIdsFromSolsort.indexOf(activeSchoolId)
      if (isIdxInBornebyArr > -1) {
        const storeObj = {
          schoolIds: schoolsIdsFromBorneby,
          isShowEventsFromOtherThanActiveSchool: false
        }
        this.$store.dispatch('readAllEvents', storeObj)
        return
      }
      if (isIdsInSolsort > -1) {
        const storeObj = {
          schoolIds: schoolIdsFromSolsort,
          isShowEventsFromOtherThanActiveSchool: false
        }
        this.$store.dispatch('readAllEvents', storeObj)
        return
      }
      if (isIdxInLillevangArr > -1) {
        const storeObj = {
          schoolIds: schoolIdsFromLillevang,
          isShowEventsFromOtherThanActiveSchool: false
        }
        if (checkIfUserIsMemberOfAllSchools(schoolIdsFromLillevang)) {
          this.$store.dispatch('readAllEvents', storeObj)
        } else {
          this.$store.dispatch('getAllDayEvents')
        }
        return
      }
      if (isIdxInHerlevArr > -1) {
        const storeObj = {
          schoolIds: schoolIdsFromHerlevBySkole,
          isShowEventsFromOtherThanActiveSchool: false
        }
        this.$store.dispatch('readAllEvents', storeObj)
        return
      }
      if (isIdxInKildeArr > -1) {
        const storeObj = {
          schoolIds: schoolIdsFromKildegaard,
          isShowEventsFromOtherThanActiveSchool: false
        }
        this.$store.dispatch('readAllEvents', storeObj)
        return
      }
      this.$store.dispatch('getAllDayEvents')
    },
    applyUserSettings (val) {
      if (!val) return

      const {selectedSubSchedulerSorting, isSubZenActive, subZenOrder} = val

      if (selectedSubSchedulerSorting) {
        this.onSortBy(selectedSubSchedulerSorting, false)
      } else if (isSubZenActive) {
        this.onSortBy('subzen', true)
      }

      if (subZenOrder) {
        this.$store.commit('setSortingHierarchy', subZenOrder)
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('getUserSubPools')
    this.$store.dispatch('subsGetLongAbsenceList')
    const localStorageAppliedFiltersForSubs = this.$helpers.getLocalStorage('d_applied_filters_subs_' + this.schoolId)
    const localStorageAppliedFiltersForAbsent = this.$helpers.getLocalStorage('d_applied_filters_absent_' + this.schoolId)
    this.appliedFilters = localStorageAppliedFiltersForSubs ? JSON.parse(localStorageAppliedFiltersForSubs) : []
    this.appliedFiltersAbsentUsers = localStorageAppliedFiltersForAbsent ? JSON.parse(localStorageAppliedFiltersForAbsent) : []
    const localStorageAppliedEventFiltersForSubs = this.$helpers.getLocalStorage('d_applied_event_filters_subs_' + this.schoolId)
    this.selectedQuickFilters = localStorageAppliedEventFiltersForSubs ? JSON.parse(localStorageAppliedEventFiltersForSubs) : []
    if (this.$helpers.getLocalStorage('subListView')) {
      this.localSchedulerView = false
    }
    this.applyUserSettings(this.userSettings)
  },
  mounted () {
    this.$store.dispatch('getAllUsers')
    this.$store.dispatch('getUsers')
    this.readEvents()
    this.getTags()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.substitution {
  display: flex;
  flex-direction: column;
}

.substitution__header__right {
  display: flex;
  justify-content: space-between;
}

.date-buttons {
  height: auto;
  white-space: nowrap;
}

.marg-5-right {
  margin-right: 5px;
}

.sub-scheduler {
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background: #fff;
  border: 1px solid #d8d8d8;
}

.sub-header__subHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.sub-scheduler__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: bold;
  border-bottom: 1px solid #d8d8d8;
}

.sub-scheduler__header__right,
.sub-scheduler__header__left {
  display: flex;
  align-items: center;
}

.sub-scheduler__header__right.sub-scheduler__header__right__filters {
  gap: 1rem;
  margin-right: 1rem;
}

.bttn--small {
  font-size: 10px;
  margin-right: 20px;
}

.sub-scheduler__filters {
  display: flex;
  align-items: center;
  border-left: 1px solid #ccc;
  padding: 10px;
  height: 40px;
}

.sub-scheduler__header__left .sub-scheduler__filters {
  border-left: 0;
}

.sub-scheduler__filters__subzen {
  position: relative;
}

.ie-warning {
  background: #ffcece;
  padding: 10px;
  color: #994545;
  border: 1px solid #994545;
  border-radius: 2px;
}

.absentUsersFilters {
  display: flex;
  background: #fff;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
}

.absentUsersFilters > div:not(:first-child) {
  margin-left: 0.5rem;
}

.absentUsersFilters__filter {
  cursor: pointer;
  background: transparent;
  border-radius: 8px;
  padding: 4px 8px;
  color: #9ca3af;
  font-weight: bold;
  transition-property: color;
  transition-duration: .15s;
  display: flex;
  align-items: center;
}

.absentUsersFilters__filter:hover {
  color: var(--dark-blue);
}

.absentUsersFilters__filter.absentUsersFilters__filter--active {
  background-color: #eee;
  color: var(--dark-blue);
}

.absentUsersFilters__filter__number {
  margin-right: 4px;
}

.d-modal__body--edit-absence {
  width: 600px;
}

.d-modal__body--edit-absence .d-modal__buttons {
  padding-top: 50px;
}

.sub-scheduler__filters label {
  margin-right: 0.5rem;
}

.sub-scheduler__filters.sub-scheduler__filters--active {
  background: aliceblue;
}

.sub-scheduler__filters.sub-scheduler__filters--active label.d-label {
  color: #222
}

.aku-button {
  display: flex;
  width: auto;
  margin-right: 1rem;
  align-items: center;
  height: 100%;
  min-height: 38px;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// Subs.vue?93bb2e38